import React from "react";
import "../styles/Projects.css";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";
import GitHubIcon from "@material-ui/icons/GitHub";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
import FadeInSection from "./FadeInSection";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const projects = {
      // "Tumor Diagnosing AI": {
      //   desc:
      //     "A neural net trained to classify malignant/benign cancerous tumors.",
      //   techStack: "Python",
      //   link: "https://github.com/samilli9/Cancer-Diagnosing-AI"
      //   // open: "https://github.com/samilli9/Cancer-Diagnosing-AI"
      // },
      "Security Camera via Facial Recognition": {
        desc:
          "A security camera leveraging Open CV to detect facial/body movement and record a short video clip of the subject.",
        techStack: "Python",
        link: "https://github.com/samilli9/Security-Camera-via-Facial-Recognition"
        // open: "https://github.com/samilli9/Security-Camera-via-Facial-Recognition"
      },
      "Handwritten Character Recognition": {
        desc:
          "Neural Net trained to recognize handwritten English characters using Open CV, Keras, and Tensorflow.",
        techStack: "Python",
        link: "https://github.com/samilli9/Handwritten-Character-Recognition"
        // open: "https://github.com/samilli9/Handwritten-Character-Recognition"
      }
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">Personal Projects</span>
        </div>

        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <FadeInSection delay={`${i + 1}00ms`}>
                <li className="projects-card">
                  <div className="card-header">
                    <div className="folder-icon">
                      <FolderOpenRoundedIcon
                        style={{ fontSize: 35 }}
                      ></FolderOpenRoundedIcon>
                    </div>
                    <span className="external-links">
                      <a className="github-icon" href={projects[key]["link"]}>
                        <GitHubIcon
                          style={{
                            fontSize: 20,
                            color: "var(--lightest-slate)"
                          }}
                        ></GitHubIcon>
                      </a>
                      {projects[key]["open"] && (
                        <a className="open-icon" href={projects[key]["open"]}>
                          <OpenInBrowserIcon
                            style={{
                              fontSize: 25,
                              color: "var(--lightest-slate)"
                            }}
                          ></OpenInBrowserIcon>
                        </a>
                      )}
                    </span>
                  </div>

                  <div className="card-title">{key}</div>
                  <div className="card-desc">{projects[key]["desc"]}</div>
                  <div className="card-tech">{projects[key]["techStack"]}</div>
                </li>
              </FadeInSection>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Projects;
